<script>
import TalkizyIntro from '@app/components/TalkizyIntro.vue';
import TalkizyJoinActions from '@app/components/TalkizyJoinActions.vue';

export default {
  name: 'TalkizyJoinTeam',
  components: { TalkizyIntro, TalkizyJoinActions },
  props: {
    canJoin: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <TalkizyIntro
    title="Rejoignez l'espace Talkizy de votre équipe "
    text="Le propriétaire de cet espace a déjà configuré Talkizy.
    Activez votre accès pour créer et animer vos propres classes virtuelles depuis le même espace."
  >
    <template #hero-actions>
      <TalkizyJoinActions
        :can-join="canJoin"
        :is-loading="isLoading"
        @join="$emit('join')"
      />
    </template>
    <!-- CTA répété en bas de page uniquement quand l'action est possible : inutile
         de dupliquer le message « demandez au propriétaire ». -->
    <template v-if="canJoin" #footer-actions>
      <TalkizyJoinActions
        :can-join="canJoin"
        :is-loading="isLoading"
        @join="$emit('join')"
      />
    </template>
  </TalkizyIntro>
</template>
